module.exports = __webpack_public_path__ + "img/service-resource02.c2df9974.jpg";